// HIER KOMEN ALLE NIEUWE PACKAGES/OUDE BOWER PACKAGES
//require('../../../node_modules/@fancyapps/fancybox/dist/jquery.fancybox.min.js');
require('jquery-countdown');